import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import { query, searchFacetChange, clearFilterOptions } from '../../Actions/Rutab/RutabFacetedSearch.action';
import { useStateWithCallbackLazy } from 'use-state-with-callback';

const FactedSearchGroupWrapper = ({ group, isFilterSelected }) => {
    const [toggleGroup, setToggleGroup] = useState(false);
    const firstRender = useRef(true);

    useEffect(() => {
        if (!firstRender.current) {
            return;
        }
        firstRender.current = false;

        if(isFilterSelected){
            setToggleGroup(true);
        }

    }, [setToggleGroup]);

    return (
        <div>
            <div
                onClick={() => setToggleGroup(!toggleGroup) }
                className="faceted-search__group-header pointer d-flex flex-with-space-between gap-1">
                <span className='align-self-center'>{group.label}</span>
                <span className='font-size--normal'>{toggleGroup ? "-":"+"}</span>
            </div>            
            <div className = { toggleGroup ? "": "Hide" }>
            <FacetedSearchGroup
                    group={group}
                    isFilterSelected={isFilterSelected}
                />
            </div> 
        </div>
    )
}

const FacetedSearchGroup = ({ group, isFilterSelected }) => {
    const [collapsed, setCollapsed] = useStateWithCallbackLazy(true);
    const showLessItemCount = useRef(15);
    const list = useRef(null);
    const firstRender = useRef(true);

    const [showItems, setshowItems] = useState(showLessItemCount.current);;

    const toggleShowMore = useCallback(() => {
        setCollapsed(
            (prevState) => !prevState,
            (collapsed) => {
                if(collapsed){
                    setshowItems(showLessItemCount.current);                  
                }
                else
                {   
                    setshowItems(group.options.length);                    
                }
            }
        );

    }, [setCollapsed]);

    useEffect(() => {        
        // Make sure it is executed only once.
        // firstRender is used to prevent eslint warning when having empty dependencies array
        if (!firstRender.current) {
            return;
        }
        firstRender.current = false;

        if(isFilterSelected){
            setshowItems(group.options.length); 
            setCollapsed(false);
        }

    }, [group, toggleShowMore]);

    const GetShowMoreQuantity = () => {
        return (group.options.length - showLessItemCount.current)
    }
    return (
        <Fragment>           
                <ul className="faceted-search__group" role="group" ref={list}>
                    <div>
                        {group.options &&
                            group.options.slice(0,showItems).map((item, itemIndex, array) => (
                                <li
                                    key={`${item.label}-${itemIndex}`}
                                    className="faceted-search__item"
                                    role="menuitemcheckbox"
                                >
                                    <FacetedFilterCheckbox item={item} group={group} />
                                </li>
                            ))}
                    </div>
                </ul>
                {group.options.length > showLessItemCount.current && (
                    <span
                        className="faceted-search__show-more"
                        onClick={toggleShowMore}
                    >
                        {`${collapsed
                            ? `${translate('filter.showmore')} (${GetShowMoreQuantity()})`
                            : translate('filter.showless')
                            }`}
                    </span>
                )}        

        </Fragment>
    );
};

const FacetedFilterCheckbox = ({ item, group }) => {
    const dispatch = useDispatch();
    const onChange = useCallback(
        (group, item) => dispatch(searchFacetChange(group, item)),
        [dispatch]
    );
    return (
        <label className="faceted-filter">
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={(event) => onChange(group, item)}
                checked={
                    group.selectedOptions != null &&
                    group.selectedOptions.includes(item.id)
                }
            />
            <span className="faceted-filter__label">
                {item.label}
                {!isNaN(item.quantity) && item.quantity != null && (
                    <span className="faceted-filter__quantity">
                        &nbsp;({item.quantity})
                    </span>
                )}
            </span>
        </label>
    );
};

const getFilteredQueryParams = () => {
    // Filter params from url so that we know if the accordions should be open on start 
    const filteredIdList = new Array();
    window.location.search.substr(1).split('&')
        .forEach(param =>
            filteredIdList.push(decodeURIComponent(param.split('=')[0])
                || ''));

    return [...new Set(filteredIdList.filter(x => x))];
}

const RutabFacetedSearch = () => {
    const dispatch = useDispatch();
    const { facetFilters, navigationTheme } = useSelector(
        (state) => state.facetedSearch
    );

    const onClear = useCallback(
        () => dispatch(clearFilterOptions()),
        [dispatch]
    );

    useEffect(() => {
        // listen to history events (back, forward) of window
        window.onpopstate =
            window.onpopstate ||
            ((event) => {
                dispatch(query(window.location.search.substr(1) || ''));
            });
    }, [dispatch]);


    const filteredQueryList = getFilteredQueryParams();

    return (
       
        facetFilters &&
        facetFilters.length > 0 && (
            <div className="faceted-search" role="menu">

                <button onClick={onClear} className='button link order-last d-none'>CLEAR</button>


                {facetFilters.map((group, groupIndex) => (
                    <FactedSearchGroupWrapper
                        key={`${group.label}-${groupIndex}`}
                        group={group}
                        isFilterSelected={filteredQueryList.find(i => i == group.id)}
                    />
                ))}


            </div>
        )
    );
};

export default RutabFacetedSearch;
